import { cn } from '@/lib/utils';

const CircleCheck = ({ className = '', ...props }: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    fill="none"
    viewBox="0 0 16 16"
    className={cn('w-4 h-4', className)}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8 2.287a5.715 5.715 0 1 1 0 11.43 5.715 5.715 0 0 1 0-11.43Zm3.28 3.272a.477.477 0 0 0-.674.02L6.837 9.592 5.395 8.056l-.034-.034a.476.476 0 0 0-.69.649l.03.037 1.512 1.61c.339.36.91.36 1.25 0L11.3 6.23a.476.476 0 0 0-.02-.672Z"
      clipRule="evenodd"
    />
  </svg>
);

export { CircleCheck };
